import vmClient from 'app/services/vmClient';
import { IWord, Word } from 'app/constants/schemas/Word';
import { ILocalWord, LocalWord } from 'app/constants/schemas/LocalWord';
import { VocabSectionWordSentence, IVocabSectionWordSentence } from 'app/constants/schemas/VocabSectionWordSentence';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

type WordAssociationUnionType = {
  word: IWord;
  localWord: null;
} | {
  word: null;
  localWord: ILocalWord;
};

export interface IVocabSectionWord extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string;
  };
  associations: WordAssociationUnionType & {
    vocabSectionWordSentences: IVocabSectionWordSentence[];
  };
}

export type VocabSectionWord = Entity<IVocabSectionWord>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabSectionWord: IEntityType<IVocabSectionWord> = vmClient.defineClass({
  typeName: 'VocabSectionWord',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
    cohortId: {
      type: 'string',
      notNull: true,
    },
  },
  associations: {
    word: {
      type: Word,
      shared: true,
    },
    localWord: LocalWord,
    vocabSectionWordSentences: {
      type: VocabSectionWordSentence,
      collection: true,
      notNull: true,
    },
  },
});
